import { render, staticRenderFns } from "./SwitchFormatter.vue?vue&type=template&id=52123514&functional=true"
import script from "./SwitchFormatter.vue?vue&type=script&lang=js"
export * from "./SwitchFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports